export const rankingMobileBreakpoint = 800;
